<small #content  [hidden]="!content.hasChildNodes()">
    <ng-content></ng-content>
</small>
